import { render } from "./Reject.vue?vue&type=template&id=0298b2f2&scoped=true"
import script from "./Reject.vue?vue&type=script&lang=js"
export * from "./Reject.vue?vue&type=script&lang=js"

import "./Reject.vue?vue&type=style&index=0&id=0298b2f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0298b2f2"]])

export default __exports__